"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));

var _material = require("@mui/material");

var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _CloseSharp = _interopRequireDefault(require("@mui/icons-material/CloseSharp"));

var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SearchDetails = function SearchDetails(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      isOpen = _ref.isOpen,
      close = _ref.close,
      searchDialogCloseLabel = _ref.searchDialogCloseLabel;
  var isMobile = (0, _useMediaQuery["default"])(function (theme) {
    return theme.breakpoints.down('md');
  });

  if (isMobile) {
    return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
      open: isOpen,
      fullScreen: true
    }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      "data-qe-id": "Search_Details_Close_Button",
      color: "inherit",
      onClick: close,
      "aria-label": searchDialogCloseLabel,
      size: "large"
    }, /*#__PURE__*/_react["default"].createElement(_CloseSharp["default"], null))), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, children));
  }

  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    id: "search-menu",
    role: "dialog",
    className: classes.menu
  }, children);
};

SearchDetails.propTypes = {
  classes: _propTypes["default"].object,
  children: _propTypes["default"].any,
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].func,
  searchDialogCloseLabel: _propTypes["default"].string
};
var _default = SearchDetails;
exports["default"] = _default;